import { makeAutoObservable, observable } from 'mobx';
import {
  BeneficiaryListDataType,
  GetBeneficiaryListType
} from '../types/beneficiary.type';
import { StorageEnum } from '../enums/storage.enum';
import { RootStore } from './root.store';
import { getBeneficiary } from './utils';

export class BeneficiaryStore {
  beneficiary: (BeneficiaryListDataType & GetBeneficiaryListType) | null = null;

  private _rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this._rootStore = rootStore;
    makeAutoObservable(this, {
      beneficiary: observable.ref
    });

    this.beneficiary = getBeneficiary();
  }

  setBeneficiary(
    newBeneficiary: BeneficiaryListDataType & GetBeneficiaryListType
  ): void {
    this.beneficiary = newBeneficiary;
    localStorage.setItem(
      StorageEnum.Beneficiary,
      JSON.stringify(this.beneficiary)
    );
  }

  clear(): void {
    this.beneficiary = null;
    localStorage.removeItem(StorageEnum.Beneficiary);
  }
}
